export const EXPORT_CSV_STATUS = {
  PROCESSING: 'processing',
  COMPLETED: 'success',
  FAILED: 'failed',
};